
import { Vertex } from './Vertex';
/**
 * Represents vertex which keeps values of one or more cells
 */
export class CellVertex extends Vertex {
    constructor() {
        super();
    }
}
